import React from 'react';
import CardABversion from './CardABversion';
import { generateRatio, getAverage } from '../../../utils';
import {
  DeliveryRateIcon,
  OpenRateIcon,
  ClickThroughRateIcon,
} from '../../SVGs/Icons';

const AllChannelsABversion = ({
  emailEvents,
  textEvents,
  isDataAvailable,
  smartResendEmailEvents,
  isSmartResendAvailable,
  messageStatus,
}) => {
  const calcSmartResendClickThroughRateForVersionA = () => {
    const oldRatio = generateRatio(
      emailEvents.uniqueclick,
      emailEvents.uniqueopen
    );

    const newRatio = generateRatio(
      emailEvents.uniqueclick + smartResendEmailEvents.emailEventsA.uniqueclick,
      emailEvents.uniqueopen + smartResendEmailEvents.emailEventsA.uniqueopen
    );

    return parseInt(newRatio) - parseInt(oldRatio) + '%';
  };

  const calcSmartResendClickThroughRateForVersionB = () => {
    const oldRatio = generateRatio(
      emailEvents.versionB.uniqueclick,
      emailEvents.versionB.uniqueopen
    );

    const newRatio = generateRatio(
      emailEvents.versionB.uniqueclick +
        smartResendEmailEvents.emailEventsB.uniqueclick,
      emailEvents.versionB.uniqueopen +
        smartResendEmailEvents.emailEventsB.uniqueopen
    );

    return parseInt(newRatio) - parseInt(oldRatio) + '%';
  };

  return (
    <>
      <CardABversion
        name="Delivery Rate Average"
        valueARatio={generateRatio(
          emailEvents.delivered + textEvents.delivered,
          emailEvents.sent + textEvents.sent
        )}
        valueACount={emailEvents.delivered + textEvents.delivered}
        valueBCount={
          emailEvents.versionB.delivered + textEvents.versionB.delivered
        }
        valueBRatio={generateRatio(
          emailEvents.versionB.delivered + textEvents.versionB.delivered,
          emailEvents.versionB.sent + textEvents.versionB.sent
        )}
        smartResendValueARatio={
          smartResendEmailEvents?.emailEventsA
            ? generateRatio(
                smartResendEmailEvents.emailEventsA.delivered,
                smartResendEmailEvents.emailEventsA.sent
              )
            : null
        }
        smartResendValueBRatio={
          smartResendEmailEvents?.emailEventsB
            ? generateRatio(
                smartResendEmailEvents.emailEventsB.delivered,
                smartResendEmailEvents.emailEventsB.sent
              )
            : null
        }
        smartResendAverageCount={
          smartResendEmailEvents?.emailEventsA
            ? getAverage(
                smartResendEmailEvents.emailEventsA.delivered,
                smartResendEmailEvents.emailEventsB.delivered
              )
            : null
        }
        title="The average of your email and text successful deliveries."
        isDataAvailable={isDataAvailable}
        isSmartResendAvailable={isSmartResendAvailable}
        messageStatus={messageStatus}
        Icon={DeliveryRateIcon}
      />
      <CardABversion
        name="Open Rate Average"
        valueARatio={generateRatio(
          emailEvents.uniqueopen +
            (smartResendEmailEvents?.emailEventsA?.uniqueopen || 0),
          emailEvents.delivered
        )}
        valueBRatio={generateRatio(
          emailEvents.versionB.uniqueopen +
            (smartResendEmailEvents?.emailEventsB?.uniqueopen || 0),
          emailEvents.versionB.delivered
        )}
        valueACount={emailEvents.uniqueopen}
        valueBCount={emailEvents.versionB.uniqueopen}
        smartResendValueARatio={
          smartResendEmailEvents?.emailEventsA
            ? generateRatio(
                smartResendEmailEvents.emailEventsA.uniqueopen,
                emailEvents.delivered
              )
            : null
        }
        smartResendValueBRatio={
          smartResendEmailEvents?.emailEventsB
            ? generateRatio(
                smartResendEmailEvents.emailEventsB.uniqueopen,
                emailEvents.versionB.delivered
              )
            : null
        }
        smartResendAverageCount={
          smartResendEmailEvents?.emailEventsA
            ? getAverage(
                smartResendEmailEvents.emailEventsA.uniqueopen,
                smartResendEmailEvents.emailEventsB.uniqueopen
              )
            : null
        }
        title="The average of your email unique open rates."
        isDataAvailable={isDataAvailable}
        isSmartResendAvailable={isSmartResendAvailable}
        showComparativeAnalytics
        messageStatus={messageStatus}
        Icon={OpenRateIcon}
      />
      <CardABversion
        name="Click-Through Rate Average"
        valueARatio={generateRatio(
          emailEvents.uniqueclick +
            (smartResendEmailEvents?.emailEventsA?.uniqueclick || 0),
          emailEvents.uniqueopen +
            (smartResendEmailEvents?.emailEventsA?.uniqueopen || 0)
        )}
        valueBRatio={generateRatio(
          emailEvents.versionB.uniqueclick +
            (smartResendEmailEvents?.emailEventsB?.uniqueclick || 0),
          emailEvents.versionB.uniqueopen +
            (smartResendEmailEvents?.emailEventsB?.uniqueopen || 0)
        )}
        valueACount={emailEvents.uniqueclick}
        valueBCount={emailEvents.versionB.uniqueclick}
        smartResendValueARatio={
          smartResendEmailEvents?.emailEventsA
            ? calcSmartResendClickThroughRateForVersionA()
            : null
        }
        smartResendValueBRatio={
          smartResendEmailEvents?.emailEventsB
            ? calcSmartResendClickThroughRateForVersionB()
            : null
        }
        smartResendAverageCount={
          smartResendEmailEvents?.emailEventsA
            ? getAverage(
                smartResendEmailEvents.emailEventsA.uniqueclick,
                smartResendEmailEvents.emailEventsB.uniqueclick
              )
            : null
        }
        title="The average of your email and text click-to-open rates."
        isDataAvailable={isDataAvailable}
        isSmartResendAvailable={isSmartResendAvailable}
        showComparativeAnalytics
        messageStatus={messageStatus}
        Icon={ClickThroughRateIcon}
      />
    </>
  );
};

export default AllChannelsABversion;
